<template>
  <v-container fill-height fluid class="container">
    <v-row align="center" justify="center">
      <v-col cols="12" sm="12" md="6" class="text-center pa-0">
        <v-progress-circular
          v-if="!dataLoaded"
          :size="70"
          :width="9"
          color="#efefef"
          indeterminate
          transition="fade-transition"
        ></v-progress-circular>
      </v-col>
    </v-row>
    <v-row
      v-if="qrcodeError"
      class="no-gutters flex-wrap flex-column fill-height"
    >
      <v-col cols="auto">
        <campaign-image
          v-if="campaign.logo"
          :imageUrl="campaign.logo" />
        <v-card
          class="mx-auto text-center"
          style="width: 90%"
          tile
          flat
        >
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title>
                <v-sheet>
                  <div class="text-center primary--text text-h4 py-4">
                    Attenzione
                  </div>
                </v-sheet>
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-card-text
            >Questa gift card risulta già utilizzata in caso di errore scrivi a segnalazione@cartadono.it
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import apiService from '@/services'
import campaignImage from '@/components/qrcode-vote-components/BaseHeaderImage'

export default {
  data () {
    return {
      dataLoaded: false, // Used to trigger form components re-rendering
      qrcodeError: false,
      isLeading: false,
      campaign: null
    }
  },
  components: {
    'campaign-image': campaignImage
  },

  mounted () {
    if (this.$route.params.qrcodeToken) {
      console.log('qrcodeToken', this.$route.params.qrcodeToken)
      this.verifyQrcode(this.$route.params.qrcodeToken)
    } else if (this.$route.params.giftCardToken) {
      console.log('giftCardToken', this.$route.params.giftCardToken)
      this.verifyGiftCard(this.$route.params.giftCardToken)
    }
  },

  methods: {
    // Verify qrCode for validation #0382C3
    verifyQrcode (qrcodeToken) {
      console.log('verifyQrcode')
      let data = {
        qrcodeToken: qrcodeToken
      }
      apiService
        .validateQrcode(data)
        .then((response) => {
          console.log('validateQrcode', response)
          sessionStorage.setItem('qrcodeToken', qrcodeToken)
          sessionStorage.setItem(
            'campaign',
            JSON.stringify(response.data)
          )
          sessionStorage.setItem(
            'token_data',
            JSON.stringify(response.data.token)
          )
          sessionStorage.setItem(
            'campaign_id',
            response.data.campaign
          )

          this.campaign = response.data
          this.$vuetify.theme.themes.light.primary = this.campaign.primary_color

          if (response.data.is_leading === true) {
            sessionStorage.setItem('isLeading', response.data.is_leading.value)
            this.isLeading = true
          } else {
            this.isLeading = false
          }

          setTimeout(() => {
            this.dataLoaded = true
            if (this.campaign.mechanism === 3) {
              console.log('SURVEY 3')
              this.$router.push({
                name: 'qrcodesurvey',
                params: {
                  logo: response.logo,
                  token: this.$route.params.qrcodeToken,
                  campaignId: sessionStorage.getItem('campaign_id'),
                  isLeading: this.isLeading,
                  sorting_type: response.sorting_type
                }
              })
            } else {
              this.$router.push({
                name: 'qrcodenpos',
                params: {
                  logo: response.logo,
                  token: this.$route.params.qrcodeToken,
                  campaignId: sessionStorage.getItem('campaign_id'),
                  isLeading: this.isLeading,
                  sorting_type: response.sorting_type
                }
              })
            }
          }, 1600)
        })
        .catch(error => {
          if (error.response.status === 409) {
            this.campaign = error.response.data
            this.$vuetify.theme.themes.light.primary = this.campaign.primary_color
          }
          setTimeout(() => {
            sessionStorage.setItem('qrcodeToken', qrcodeToken)
            this.dataLoaded = true
            this.qrcodeError = true
          }, 1600)
        })
    },

    // Verify giftCard for validation
    verifyGiftCard (giftCardToken) {
      console.log('verifyGiftCard', giftCardToken)
      apiService
        .validateGiftCard(giftCardToken)
        .then((response) => {
          console.log('validatedGiftCard', response)
          sessionStorage.setItem('giftCardToken', giftCardToken)
          sessionStorage.setItem(
            'campaign',
            JSON.stringify(response.data)
          )
          sessionStorage.setItem(
            'token_data',
            JSON.stringify(response.data.token)
          )
          sessionStorage.setItem(
            'campaign_id',
            response.data.campaign
          )

          this.campaign = response.data

          // change campaign color
          this.$vuetify.theme.themes.light.primary = this.campaign.primary_color

          this.isLeading = false

          // Push to next page
          setTimeout(() => {
            this.dataLoaded = true
            this.$router.push({
              name: 'giftcardnpolist',
              params: {
                logo: response.logo,
                token: this.$route.params.giftCardToken,
                campaignId: sessionStorage.getItem('campaign_id'),
                isLeading: this.isLeading,
                sorting_type: response.sorting_type
              }
            })
          }, 1000)
        })
        .catch(error => {
          console.log('ERROR', error)
          if (error.response.status === 409) {
            this.campaign = error.response.data
            this.$vuetify.theme.themes.light.primary = this.campaign.primary_color
          }
          setTimeout(() => {
            sessionStorage.setItem('giftCardToken', giftCardToken)
            this.dataLoaded = true
            this.qrcodeError = true
          }, 1000)
        })
    }
  }
}
</script>
<style scoped>
.container {
  background-color: #fff;
  padding: 0;
}
</style>
